<div class="container" [attr.data-intro]="'help.scanner' | translate"
     *ngIf="!scannerEnabled" [ngStyle]="{'width': iconWidth, 'height': iconHeight}">
    <ion-img src="assets/barcode-scan-icon.jpg" (click)="doScan()"></ion-img>
    <ion-spinner class="loading" *ngIf="loading" name="lines" color="primary"></ion-spinner>
</div>
<ng-container *ngIf="scannerEnabled">
    <div class="scanner" [ngStyle]="{'width': liveWidth, 'height': liveHeight}" (click)="doStop()">
        <div>{{'scan.close' | translate}}</div>
        <ion-spinner class="loading" *ngIf="loading" name="lines" color="primary"></ion-spinner>
        <zxing-scanner #scanner class="scanner"
                       previewFitMode="fill"
                       [formats]="allowedFormats"
                       [autofocusEnabled]="true"
                       [torch]="true"
                       [device]="scannerDevice"
                       (camerasFound)="camerasFoundHandler($event)"
                       (scanSuccess)="scanSuccessHandler($event)"
                       (scanFailure)="scanErrorHandler($event)"
                       (scanError)="scanErrorHandler($event)"
        ></zxing-scanner>
    </div>
</ng-container>
